(function () {
  function initCompareTable(root) {
    var scroller = root.querySelector('[id^="FmCompareScroll-"]');
    var thumb = root.querySelector('[id^="FmCompareThumb-"]');
    var nextBtn = root.querySelector('[id^="FmCompareNext-"]');
    var prevBtn = root.querySelector('[id^="FmComparePrev-"]');
    if (!scroller || !thumb) return;

    function updateThumb() {
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if (maxScroll <= 0) {
        thumb.style.width = '100%';
        thumb.style.transform = 'translateX(0)';
        return;
      }
      var visibleRatio = scroller.clientWidth / scroller.scrollWidth;
      var trackWidth = thumb.parentElement.clientWidth;
      var thumbWidth = Math.max(trackWidth * visibleRatio, 24);
      var progress = scroller.scrollLeft / maxScroll;
      var maxTranslate = trackWidth - thumbWidth;

      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + progress * maxTranslate + 'px)';
    }

    scroller.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', updateThumb);
    updateThumb();

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scroller.scrollBy({ left: scroller.clientWidth * 0.7, behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scroller.scrollBy({ left: scroller.clientWidth * -0.7, behavior: 'smooth' });
      });
    }
  }

  document.querySelectorAll('.fm-compare').forEach(initCompareTable);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.fm-compare');
    if (section) initCompareTable(section);
  });
})();
